import { NeutralButton } from "../../common/Buttons"
import ActionConfirmDrawer from "../../common/ActionConfirmDrawer"
import useStore from "../../../store"
import { useState } from "react"

export default function MarkUnsold({ unit }) {
  const markUnitUnsold = useStore((state) => state.markUnitUnsold)
  const markingUnitUnSold = useStore((state) => state.markingUnitUnSold)
  const [isOpen, setIsOpen] = useState(false)

  return(
    <>
      <NeutralButton
        onClick={() => setIsOpen(true)}
        text="Mark Unsold"
        dataTestId="mark-unsold"
        loading={markingUnitUnSold}
      />
      <ActionConfirmDrawer
        title="Mark Unsold"
        body="Are you sure you want to mark this unit as unsold?"
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        onConfirm={() => {
          markUnitUnsold(unit)
          setIsOpen(false)
        }}
        onCancel={() => setIsOpen(false)}
      />
    </>
  )
}
